//디바이스 체크 유틸

export const isIOS = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
}

export const isAndroid = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return /android/i.test(userAgent);
}

/**
 * 현재 환경이 위챗 미니앱인지 확인
 * 일단 환자앱에 있는 deviceCheck를 가져옴...
 * 장기적으로 병원앱에도 isMiniApp이 필요한 지는 조금 미지수라 일단 주석처리
 */
// export const isMiniapp = () => {
//     const userAgent = navigator.userAgent || navigator.vendor || window.opera;
//     if (/wechat/i.test(userAgent) || /miniProgram/i.test(userAgent)) {
//         return true;
//     }
//     return false;
// }

/**
 * 현재 환경이 병원앱 iOS/Android인지, 혹은 카카오톡, 기타앱의 인앱브라우저인지 확인
 */
//TODO: App/Web 둘 다 고도화된 규격으로 유저에이전트를 다뤄야 함
// App이 "CERTILIFE_USER_AGENT_PREFIX / valueA / valueB / valueC / CERTILIFE_USER_AGENT_SUFFIX" 형태로 보내게 수정을 하면
// Web, Server는 위 규격에서 필요한 값을 가져다 쓰게끔 하게끔 고도화 되어야 함
export const isCertilifeHostApp = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (userAgent.includes('CERTILIFE_USER_AGENT')) {
        return true
    } else {
        return false
    }
}